import nanoid from "./uuid";

export const generateReportId = () => `r1-${nanoid()}`;
